import React, {Component} from 'react';
import {connect} from 'react-redux'
import './styles/PopAnimationImage.css';
import Image from '../components/Image';

window.onload = function () {
    let PopAnimationImages = document.querySelectorAll(".pop-image");

    let isInViewport = function (elem) {
        let bounding = elem.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };


    function checkView() {
        PopAnimationImages.forEach(function (image) {
            if (isInViewport(image)) {
                image.classList.add("active");
            }
        })
    }

    window.addEventListener('scroll', function () {
        PopAnimationImages = document.querySelectorAll(".pop-image:not(.active)");
        checkView();
    });

    checkView();
};

class PopAnimationImage extends Component {
    constructor(props) {
        super(props);
        const graduatesWithImages = this.props.graduates.filter(graduate => (
            graduate.image.placeholder === undefined
        ));
        const images = graduatesWithImages.map(graduate => graduate.image.full);
        this.state = {
            images: images,
            index: Math.floor(Math.random() * images.length),
            nextIndex: Math.floor(Math.random() * images.length)
        };
    }


        intervalFunction =() => {
            this.setState({
                fade: true,
            });
            setTimeout(() => {
                this.setState({
                    fade: false,
                    index: this.state.nextIndex,
                    nextIndex: Math.floor(Math.random() * this.state.images.length),
                })
            }, 1000); };

    componentDidMount(){
        setInterval(this.intervalFunction, 3000);
    }

    render() {
        const fade = this.state.fade ? 'fade' : '';

        return (
            <div className="pop-image">
                <div className={'borders'}>
                    <div className={`border ${'border--' + this.props.colors[0]}`}/>
                    <div className={`border ${'border--' + this.props.colors[1]}`}/>
                </div>
                <div className={"images"}>
                    <Image src={this.state.images[this.state.index]}
                         className={`current`} aspectRatio={'4:4'} cover position={'center 10%'}
                    />
                    <Image src={this.state.images[this.state.nextIndex]}
                         className={`next ${fade}`} aspectRatio={'4:4'} cover position={'center 10%'}
                    />
                </div>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    graduates: state.graduates,
});

export default connect(MapStateToProps)(PopAnimationImage);
